<template>
	<div class="table-wrap">
		<el-row style="padding:0 0 10px 0">
			<el-button size="small" @click.stop="downLoadDataClick">下载数据</el-button>
		</el-row>
		 <!-- 表格 -->
		<el-table
			header-row-class-name="data-table-header"
			:data="linkSummary.content"
			@row-click="linkDetail"
			tooltip-effect="dark"
			style="width: 100%"
			>
			<el-table-column label="序号" fixed="left" type="index" width="50"></el-table-column>
			<el-table-column label="商品名称" prop="itemtitle" width="400">
				<template slot-scope="scope">
					<div @click.stop>
						<span class="lowTag" v-if="scope.row.islowprice">低</span>
						<img class="cell-img" :src="scope.row.picurl" alt="">
						<div class="link-wrap">
							<el-link
								:href="scope.row.itemlink"
								:underline="false"
								target="_blank"
							>{{scope.row.itemtitle}}</el-link>
							<el-link
								type="primary"
								:href="scope.row.itemlink"
								:underline="false"
								target="_blank"
							>{{scope.row.itemlink}}</el-link>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="shopname" label="店铺名称" width="300">
				<template slot-scope="scope">
					<div>
						<span style="vertical-align: text-bottom;margin: 0 5px 0 0;">{{ scope.row.shopname }}</span>
						<Shopname :platform="scope.row.platform" />
						<ShopType :shoptype="scope.row.shoptype"/>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="wangwang" label="旺旺名">
				<template slot-scope="scope">
					<span>{{scope.row.wangwang}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="area" label="发货地">
				<template slot-scope="scope">
					<span>{{scope.row.area}}</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="100" class-name="operate" fixed="right">
				<template slot-scope="scope">
					<span class="op-btn" @click="linkDetail(scope.row)">详情</span>
				</template>
			</el-table-column>
		</el-table>
		<Pagination
			v-if="linkSummary.totalElements"
			class="pagination"
			:total="linkSummary.totalElements"
			:pagination="query"
			@onChange="load"
		/>
		<!-- 详情弹框 -->
    <linkDealModal :modalInfo="detailModalInfo" ref="detailModal" @reqTableData="load" />
	</div>
</template>
<script>
import Pagination from "@/components/pagination/pagination";
import Shopname from "@/components/shopname/Shopname.vue";
import ShopType from "@/components/shopType";
import linkDealModal from "./linkDealModal";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
	name:'linkSummaryList',
	components: { Pagination, Shopname, ShopType, linkDealModal },
	props:{
		searchform:{
			type:Object,
			default:()=>{}
		},
		pageName:String
	},
	data(){
		return {
			query: {
        size: 10,
        current: 1,
      },

      detailModalInfo: { isShow: false }
		}
	},
	computed:{
		...mapState({ 
			linkSummary: state => state.linkSummary.linkSummary
		}),
	},
	created(){
		if(!this.pageName){
			this.load();
		}
	},
	methods:{
		...mapActions(["reqLinkSummary","reqLinkSummaryDetail","reqItemByIdAndTimeList"]),
    getParams() {
      let params = {
        pageNo: this.query.current,
        pageSize: this.query.size,
        ...this.searchform
      };
      return params;
    },
    load() {
			if(!this.pageName){
				let params = this.getParams();
				this.reqLinkSummary(params);
			}else{
				let query = {
					pageNo: this.query.current,
					pageSize: this.query.size,
					id:this.$route.query.id,
					monitortime:this.$route.query.monitortime,
					openid:'web',
					islowprice:0
				}
				this.reqItemByIdAndTimeList(query);
			}
    },
    getParamUrl(data) {
      let url = "";
      for (var k in data) {
        let value = data[k] && data[k] !== undefined ? data[k] : "";
        url += `&${k}=${encodeURIComponent(value)}`;
      }
      return url ? url.substring(1) : "";
    },
    // 下载数据
    downLoadDataClick() {
			if(this.pageName){
				this.$emit('downLoadData');
				return
			}
      let params = this.getParamUrl(this.searchform);
      let url = `hcm/hcmNewMonitorProduct/DownloadDetailPage?${params}`;
      window.open(url);
    },
    // 右侧详情
    linkDetail(row) {
      this.detailModalInfo.isShow = true;
			this.detailModalInfo.row = {...row};
			let query = {
				itemid:row.itemid,
				pageNo:1,
				pageSize:10,
				skuid:row.skuID
			};
      this.reqLinkSummaryDetail(query);
    }
	}
}
</script>
<style lang="scss">
@import "src/style/dataTable";
.el-table__fixed-right::before,
.el-table__fixed::before {
  z-index: -1;
}
.el-table__body tr.hover-row {
  cursor: default !important;
}

.content-warpper{
	.cell-img{
		width: 66px;
		margin-right: 4px;
		margin-left: 12px;
	}
	.link-wrap{
		display: inline-block;
    width: calc(100% - 84px);
	}
} 
.lowTag{
	display: inline-block;
	background-color: red;
	width: 17px;
	height: 17px;
	color: white;
	text-align: center;
	line-height: 17px;
	border-radius: 20px;
	font-size: 12px;
	position: absolute;
	left: 0;
	top: 35px;
}

.pagination {
	margin: 10px 0 0 0;
	text-align: right;
	.el-pagination__jump{
		margin-left: 0;
	}
}
</style>